import React, { useContext } from "react"
import { Link, useLocation } from "react-router-dom"
import { Button } from "../../components/common/button/Button"
import { Seperator } from "../../components/common/seperator/seperator"
import { TextLink } from "../../components/common/TextLink/TextLink"
import VehicleInfoContainer from "../../components/common/VehicleInfoContainer/VehicleInfoContainer"
import { VehicleCondition } from "../../components/vehicle-condition/VehicleCondition"
import { AppContext, AppContextInterface } from "../../state/ContextProvider"
import { checkPath } from '../../utils/validation-utils'

const VehicleDetails: React.FC = () => {
  const { search } = useLocation()
  const {
    actions: { addVehicleCondition },
    state: { vehicleCondition },
  } = useContext(AppContext) as AppContextInterface

  return (
    <div className="vehicle-details-container">
      <VehicleInfoContainer />
      <div className="inner-container">
        <h2 className="vehicle-details-heading">Vehicle details</h2>
        <p className="vehicle-paragraph">
          Enter your vehicle's details accurately to receive our most precise vehicle valuation
        </p>
        <Seperator />
        <div>
          <VehicleCondition
            vehicleCondition={vehicleCondition}
            addVehicleCondition={addVehicleCondition}
          />
          <Seperator />
          <Link className="text-link" to={`/contact-details${checkPath(search)}`}>
            <Button
              disabled={vehicleCondition ? false : true}
              type="button"
              variant="blue"
            >
              NEXT STEP
            </Button>
          </Link>
          <Link className="text-link" to={`/confirm-vehicle/${search}`}>
            <Button type="button" variant="white">
              PREVIOUS STEP
            </Button>
          </Link>
          <TextLink text="Change vehicle" href="/" />
        </div>
      </div>
    </div>
  )
}

export default VehicleDetails
